/**
 * グラフエクスポート用：カメラアイコン＋プルダウン（クリップボード / PNG / SVG / TIFF / JPEG）
 */

import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styles from './KeisukeDashboardChart.module.scss';

interface KeisukeDashboardChartExportDropdownProps {
  onCopyClipboard: () => void;
  onExportPng: () => void;
  onExportSvg: () => void;
  onExportTiff: () => void;
  onExportJpeg: () => void;
}

export function KeisukeDashboardChartExportDropdown({
  onCopyClipboard,
  onExportPng,
  onExportSvg,
  onExportTiff,
  onExportJpeg,
}: KeisukeDashboardChartExportDropdownProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.chartExportToolbar} aria-label={t('keisuke.dashboard.export')}>
      <Dropdown align="end" drop="down">
        <Dropdown.Toggle
          variant="link"
          className={styles.chartExportDropdownToggle}
          id="chart-export-dropdown"
          title={t('keisuke.dashboard.tooltips.exportChartMenu')}
          aria-label={t('keisuke.dashboard.exportChart')}
        >
          <i className="fas fa-camera" aria-hidden />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={onCopyClipboard}>
            {t('keisuke.dashboard.exportClipboard')}
          </Dropdown.Item>
          <Dropdown.Item onClick={onExportPng}>
            {t('keisuke.dashboard.exportPng')}
          </Dropdown.Item>
          <Dropdown.Item onClick={onExportSvg}>
            {t('keisuke.dashboard.exportSvg')}
          </Dropdown.Item>
          <Dropdown.Item onClick={onExportTiff}>
            {t('keisuke.dashboard.exportTiff')}
          </Dropdown.Item>
          <Dropdown.Item onClick={onExportJpeg}>
            {t('keisuke.dashboard.exportJpeg')}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
